import React from 'react';
import {useStore} from "@/app/providers/StoreProvider";
import {OviFlexModal} from "@/entities/modals/ui/OviFlexModal";
import {observer} from "mobx-react-lite";
import {BuyItemModal} from "@/entities/modals/ui/BuyItemModal";
import {StartPackModal} from "@/entities/modals/ui/StartPackModal";
import {QuestCheckModal} from "@/entities/modals/ui/QuestCheckModal";
import {QuestDailyModal} from "@/entities/modals/ui/QuestDailyModal";
import {QuestInputModal} from "@/entities/modals/ui/QuestInputModal";
import {LuckyModal} from "@/entities/modals/ui/LuckyModal";
import {QuestCompletedModal} from "@/entities/modals/ui/QuestCompletedModal";
import {QuestDeclinedModal} from "@/entities/modals/ui/QuestDeclinedModal";

export const Modals = observer(() => {

    const { modalStore } = useStore();
    const modal = modalStore.currentModal;

    if (!modal) return null;

    switch (modal.type) {
        case "destroyOviFlex":
            return <OviFlexModal />;
        case "buyItem":
            return <BuyItemModal {...modal.payload} />;
        case "startPack":
            return <StartPackModal {...modal.payload} />;
        case "questCheck":
            return <QuestCheckModal {...modal.payload} />;
        case "questDaily":
            return <QuestDailyModal {...modal.payload} />;
        case "questInput":
            return <QuestInputModal {...modal.payload} />;
        case "questCompleted":
            return <QuestCompletedModal {...modal.payload} />;
        case "questDeclined":
            return <QuestDeclinedModal {...modal.payload} />;
        case "lucky":
            return <LuckyModal {...modal.payload} />;
    }
});
